import { render, staticRenderFns } from "./OpportunityNegotiationForm.vue?vue&type=template&id=12a1c0de&scoped=true&"
import script from "./OpportunityNegotiationForm.vue?vue&type=script&lang=js&"
export * from "./OpportunityNegotiationForm.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityNegotiationForm.vue?vue&type=style&index=0&id=12a1c0de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a1c0de",
  null
  
)

export default component.exports